import axios, { AxiosError } from 'axios';
import axiosRetry from 'axios-retry';
import { RemoteError } from '../redux/SharedTypes';
import { isRemoteError } from './errorMessageHelper/errorMessageHelper';

const instance = axios.create({
	headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
	withCredentials: true,
});

axiosRetry(instance, {
	retryCondition: (error: AxiosError<unknown | RemoteError>) =>
		isRemoteError(error.response?.data) && error.response?.data.errorCode === 'AP_7',
	retries: 1,
});

export default instance;
